<template>
  <a-modal width="50vw"
           :footer="false"
           :closable="false"
           :visible="visible"
           :destroyOnClose="true">
    <template slot="title">
      <div class="modal-title">
        评审专家履职承诺书
      </div>
    </template>
    <a-card>
      <div class="content">
        <p class="color-black">本人自愿加入{{ sys_title }}的专家库，并作出以下承诺:</p>
        <p class="color-black">1、本人所填写、提供的申请材料真实有效，并对申请材料的真实性负责；</p>
        <p class="color-black">2、符合相关法律法规要求，可以成为评审专家的条件:</p>
        <p>(一)具有良好的职业道德，廉洁自律，遵纪守法，无行贿、受贿、欺诈等不良信用记录，申请成为评审专家前三年内，无法规规定的不良行为记录；</p>
        <p>(二)具有中级专业技术职称或同等专业水平且从事相关领域工作满8年，或者具有高级专业技术职称或同等专业水平；</p>
        <p>(三)熟悉招标采购相关政策法规和申请评审专业相关产业发展、市场供给等情况，能够胜任招标采购项目咨询、审查、论证、评审、验收等相关工作；</p>
        <p>(四)承诺以独立身份参加评审工作，依法履行评审专家工作职责并承担相应法律责任的中国公民；</p>
        <p>(五)能够熟练操作使用计算机独立完成评审工作；</p>
        <p>(六)不满70周岁，身体健康，能够承担评审工作。</p>
        <p class="color-black">3、秉持诚实守信，恪守职业道德，客观、公正、审慎地开展评审工作并承担相应的法律责任；</p>
        <p class="color-black">4、本人身体健康，能够胜任评审工作，能以独立身份参与招标采购评审活动，自行承担因个人身体健康状况在评审过程中引发的相关风险；</p>
        <p class="color-black">5、遵守评审工作纪律，遵守招标采购保密规定，不向他人透露对投标文件的评审和比较、中标候选人的推荐情况以及与评标有关的其他情况；</p>
        <p class="color-black">6、主动回避与本人有利害关系的评审活动；</p>
        <p class="color-black">7、积极配合采购人或采购代理机构做好供应商询问、质疑和投诉处理以及监管部门的监督检查；</p>
        <p class="color-black">8、不私自建立或加入可能影响不利于公正、独立评审的自媒体群微信群及其他社交媒体群；</p>
        <p class="color-black">9、廉洁自律，按照广东省关于评审专家劳务报酬的相关规定获取劳务报酬，不额外索要劳务报酬或其他不正当利益；</p>
        <p class="color-black">10、未经{{ sys_title }}委派，不擅自以{{ sys_title }}的名义从事相关活动。</p>
      </div>
      <div style="text-align: center;margin-top: 10px">
        <a-button type="primary"
                  @click="()=>{visible=false;$emit('handleAgree')}">
          我已阅读并同意
        </a-button>
      </div>
    </a-card>
  </a-modal>
</template>

<script>
import { GetContentResourceByKey } from '@/epp/sysContentMange/api/sysContentMangeApi'
import { SYS_TITLE } from '@/store/mutation-types'

export default {
  name: 'ExpertApplyForCommitmentModal',
  data () {
    return {
      visible: false,
      sys_title: undefined,
    }
  },
  created () {
  },
  methods: {
    async init () {
      this.sys_title = await GetContentResourceByKey(SYS_TITLE, '0')
      this.visible = true
    }
  }
}
</script>

<style lang="less" scoped>
.card {
  margin-bottom: 24px;

  .extras {
    font-weight: 500;
    font-size: 16px;
  }
}

.modal-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.content {
  font-size: 16px;
  overflow-y: scroll;
  height: 600px;
}

.color-black {
  color: black;
  //加粗
  font-weight: bold;
}
</style>
